import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Client-side redirect from old Railway domain to new domain
if (window.location.hostname.includes('poe-idol-planner-production.up.railway.app')) {
  const newUrl = `https://idolplanner.easyexile.tools${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(newUrl);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);